export default __webpack_public_path__ + "media/images/main/select2-f982fe6eb537ed780e6a85cc5ab28722.png";